import { PanelStore } from './../requests/panel/panel.store';
import { RequestsSharedModule } from './../requests/@shared/requests.shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Angulartics2Module } from 'angulartics2';

import { SharedModule } from '@shared';
import { MaterialModule } from '@app/material.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { RequestsModule } from '@app/requests/requests.module';
import { PanelModule } from '@app/requests/panel/panel.module';
import { SearchStore } from '@app/users/operation-search/search-store';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    FlexLayoutModule,
    MaterialModule,
    Angulartics2Module,
    HomeRoutingModule,
    RequestsSharedModule,
    RequestsModule,
  ],
  declarations: [HomeComponent],
  providers: [PanelStore, SearchStore],
})
export class HomeModule {}
